const AlertsCompanyHead = function AlertsCompanyHead() {
  return (
    <div className="heading-panel">
      <h6 className="head">Companies:</h6>
    </div>
  );
};

export default AlertsCompanyHead;
